import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const AccordionContainer = ({ children, isOpen, wasOpen }) => {
    const [styles, setStyles] = useState({ maxHeight: wasOpen ? 93 : 0 });

    const ref = useRef();

    useEffect(() => {
        if (isOpen === wasOpen) return;
        const { scrollHeight } = ref.current;
        setStyles({
            ...styles,
            maxHeight: isOpen ? scrollHeight : 0,
        });
    }, [isOpen, wasOpen]);

    return (
        <div ref={ref} className="collapse" style={styles}>
            {children}
        </div>
    );
};
AccordionContainer.propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    wasOpen: PropTypes.bool,
};

export default AccordionContainer;
